import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getAuth,
  setPersistence,
  browserLocalPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFirebaseEnv, validateFirebaseEnv } from "../lib/env";

const firebaseConfig = getFirebaseEnv();
const envCheck = validateFirebaseEnv();

if (!envCheck.ok && process.env.NODE_ENV === "development") {
  console.error(
    "[Firebase] Missing .env values:",
    envCheck.missing.join(", "),
    "— restart npm start after editing host/.env"
  );
}

const app = getApps().length ? getApp() : initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

setPersistence(auth, browserLocalPersistence).catch(() => {});
